/* Lead Time Calculator page (sections/lead-time-calculator.liquid), 2026-10-21.
   Product search, the day-by-day timeline, what-ifs, compare and send. Date math: assets/lead-time.js.
   Plain ES5 like the rest of the theme. */
(function () {
  'use strict';
  var L = window.IDPSLeadTime;
  var form = document.getElementById('ltc-form');
  var root = document.getElementById('ltc');
  if (!L || !form || !root) return;

  var UPS_URL = 'https://ups-rate-proxy.idproductsource.workers.dev/rate';
  var MAX_ITEMS = 6;
  var MAX_DAYS = 75;

  function $(id) { return document.getElementById(id); }
  var els = {
    q: $('ltc-q'), list: $('ltc-list'), pick: $('ltc-pick'), order: $('ltc-order'), event: $('ltc-event'),
    zip: $('ltc-zip'), ship: $('ltc-ship'), err: $('ltc-err'), empty: $('ltc-empty'), results: $('ltc-results'),
    sum: $('ltc-sum'), tl: $('ltc-tl'), steps: $('ltc-steps'), wi: $('ltc-wi'),
    cmpAdd: $('ltc-cmp-add'), cmpCombo: $('ltc-cmp-combo'), cmpQ: $('ltc-cmp-q'), cmpList: $('ltc-cmp-list'),
    cmpRows: $('ltc-cmp-rows'), cmpMsg: $('ltc-cmp-msg'), company: $('ltc-company'), copy: $('ltc-copy'),
    print: $('ltc-print'), mail: $('ltc-mail'), quote: $('ltc-quote'), status: $('ltc-status'), printHead: $('ltc-print-head')
  };

  /* main = the product being planned; items = main + compared products */
  var S = { main: null, items: [], changes: false, late: false, transit: {}, pending: {} };

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function today() { var n = new Date(); return L.day(n.getFullYear(), n.getMonth() + 1, n.getDate()); }
  function inputDate(el) { return L.parseDate(el && el.value); }
  function method() { var m = els.ship.value; return L.METHODS[m] ? m : 'ground'; }
  function zipOk() { return /^\d{5}$/.test(els.zip.value.trim()); }
  function sameYear(d) { return d.getFullYear() === today().getFullYear(); }
  function fd(d) { return L.fmt(d, !sameYear(d)); }
  function fr(a, b) { return L.fmtRange(a, b, !sameYear(b)); }
  function short(d) { return L.DOW[d.getDay()] + ' ' + d.getDate(); }
  function daysTxt(r) { return r.lo === r.hi ? r.lo + '' : r.lo + '–' + r.hi; }

  /* ── products ── */
  function prep(p) {
    if (!p || !p.handle) return null;
    p.range = L.parseRange(p.lead);
    p.cal = L.prodCountry(p.origin, p.ships);
    p.oz = L.originKey(p.id, p.ships);   // the rate worker looks the origin up from the product id
    p.direct = L.shipsDirect(p.ships);
    return p;
  }
  function whereTxt(p) {
    if (p.cal === 'CN') return 'Produced overseas (China)';
    if (p.cal === 'MX') return 'Produced in Mexico';
    return /decorated/i.test(p.origin || '') ? 'Decorated in the USA' : 'Made in the USA';
  }
  function shipsTxt(p) {
    if (p.direct) return 'Made overseas, ships to us first';
    var m = /\(([^)]+)\)/.exec(p.ships || '');
    return m ? 'Ships from ' + m[1] : (p.ships ? 'Ships from ' + p.ships : '');
  }

  /* the sections put their JSON in an HTML-escaped attribute (data-lt-suggest / data-lead-time-data) */
  function parseJson(html, attr) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var s = doc.querySelector('[' + attr + ']');
      return s ? JSON.parse(s.getAttribute(attr)) : null;
    } catch (e) { return null; }
  }
  function search(q) {
    var u = '/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=lead-time-suggest';
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      var a = parseJson(t, 'data-lt-suggest');
      return (Array.isArray(a) ? a : []).map(prep).filter(Boolean);
    }).catch(function () { return []; });
  }
  function byHandle(h) {
    return fetch('/products/' + encodeURIComponent(h) + '?section_id=lead-time-data', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { return prep(parseJson(t, 'data-lead-time-data')); })
      .catch(function () { return null; });
  }
  /* an item number from a link (?sku=) or typed + Enter: exact match first, then the product address */
  function lookupSku(sku) {
    var want = String(sku || '').trim().toUpperCase();
    if (!want) return Promise.resolve(null);
    return search(want).then(function (list) {
      for (var i = 0; i < list.length; i++) if (String(list[i].item).toUpperCase() === want) return list[i];
      return byHandle(want.toLowerCase());
    });
  }

  /* ── shipping days ── */
  function transitFor(p) {
    var m = method();
    var M = L.METHODS[m];
    if (M.days != null) return { days: M.days, src: 'fixed', name: M.name };
    if (!zipOk()) return { days: L.GROUND_ALLOWANCE, src: 'nozip', name: M.name };
    var k = p.oz + '>' + els.zip.value.trim();
    if (typeof S.transit[k] === 'number') return { days: S.transit[k], src: 'ups', name: M.name };
    if (S.transit[k] === null) return { days: L.GROUND_ALLOWANCE, src: 'fail', name: M.name };
    fetchTransit(p, els.zip.value.trim());
    return { days: L.GROUND_ALLOWANCE, src: 'wait', name: M.name };
  }
  function fetchTransit(p, zip) {
    var k = p.oz + '>' + zip, ob = L.originBody(p.id, p.ships);
    if (S.pending[k]) return;
    S.pending[k] = 1;
    fetch(UPS_URL, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: ob.productId, shipsFrom: ob.shipsFrom, destZip: zip, weightLbs: 2, transit: true, services: ['03'] })
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var n = null;
      var rates = j && j.rates || [];
      for (var i = 0; i < rates.length; i++) if (rates[i].code === '03' && rates[i].businessDays) n = parseInt(rates[i].businessDays, 10);
      S.transit[k] = (n > 0 && n < 15) ? n : null;
    }).catch(function () { S.transit[k] = null; }).then(function () { delete S.pending[k]; render(); });
  }

  /* ── plans ── */
  function opts(p, over) {
    over = over || {};
    var ch = over.changes != null ? over.changes : S.changes;
    var tr = over.transit != null ? { days: over.transit } : transitFor(p);
    return {
      order: inputDate(els.order) || today(), lo: p.range.lo, hi: p.range.hi, cal: p.cal,
      approveLate: (over.late != null ? over.late : S.late) ? 1 : 0, changesLo: ch ? 1 : 0, changesHi: ch ? 2 : 0, transit: tr.days
    };
  }
  function planFor(p, over) { return L.plan(opts(p, over)); }

  /* ── search box (used twice: the hero card and "Add a product") ── */
  function combo(input, list, onPick) {
    var seq = 0, items = [], active = -1, timer = null;
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function open() { list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function setActive(i) {
      var opts = list.querySelectorAll('[role="option"]');
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      for (var j = 0; j < opts.length; j++) opts[j].setAttribute('aria-selected', j === active ? 'true' : 'false');
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }
    function draw(q) {
      if (!items.length) {
        list.innerHTML = '<li class="ltc-list__none">No products match “' + esc(q) + '”. Try the item number.</li>';
        open();
        return;
      }
      list.innerHTML = items.map(function (p, i) {
        var lt = p.range ? daysTxt(p.range) + ' days' : 'No time listed';
        return '<li class="ltc-opt-row" role="option" id="' + list.id + '-o' + i + '" aria-selected="false" data-i="' + i + '">' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="ltc-noimg"></span>') +
          '<span class="ltc-opt-row__t"><b>' + esc(p.name) + '</b><span>' + esc(p.item) + '</span></span>' +
          '<span class="ltc-opt-row__d">' + esc(lt) + '</span></li>';
      }).join('');
      open();
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      var my = ++seq;
      search(q).then(function (r) { if (my !== seq) return; items = r; active = -1; draw(q); });
    }
    function choose(i) {
      var p = items[i];
      if (!p) return;
      close();
      onPick(p);
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
    input.addEventListener('focus', function () { if (items.length && input.value.trim().length > 1) draw(input.value.trim()); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) run(); else setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { if (!list.hidden) { e.preventDefault(); close(); } }
      else if (e.key === 'Enter') {
        e.preventDefault();
        if (!list.hidden && active > -1) { choose(active); return; }
        var q = input.value.trim();
        if (!q) return;
        clearTimeout(timer);
        var my = ++seq;
        lookupSku(q).then(function (p) {
          if (my !== seq) return;
          if (p) { close(); onPick(p); } else run();
        });
      }
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('[role="option"]');
      if (li) choose(+li.getAttribute('data-i'));
    });
    document.addEventListener('click', function (e) { if (!list.hidden && e.target !== input && !list.contains(e.target)) close(); });
    return { close: close };
  }

  function setMain(p, quiet) {
    S.main = p;
    S.items = [p].concat(S.items.slice(1).filter(function (x) { return x.handle !== p.handle; }));
    els.q.value = '';
    els.err.hidden = true;
    render();
    if (!quiet) syncUrl();
  }
  function addItem(p) {
    if (!S.main) { setMain(p); return; }
    for (var i = 0; i < S.items.length; i++) if (S.items[i].handle === p.handle) { say(p.item + ' is already on the list.'); return; }
    if (S.items.length >= MAX_ITEMS) { say('Up to ' + MAX_ITEMS + ' products at a time.'); return; }
    S.items.push(p);
    els.cmpQ.value = '';
    render();
    syncUrl();
  }

  /* ── rendering ── */
  function render() {
    var p = S.main;
    renderPick();
    if (!p) { els.results.hidden = true; els.empty.hidden = false; return; }
    els.empty.hidden = true;
    els.results.hidden = false;
    if (!p.range) {
      els.sum.innerHTML = sumHead(p) + '<div class="ltc-sum__none"><b>This product doesn’t list a production time yet.</b> Ask us for a date and we’ll confirm it. <a class="ltc-btn" href="' + esc(p.url) + '?action=quote">Request a quote</a></div>';
      els.tl.innerHTML = ''; els.steps.innerHTML = ''; els.wi.innerHTML = ''; renderCompare(); renderSend(null); return;
    }
    var pl = planFor(p);
    var ev = inputDate(els.event);
    renderSum(p, pl, ev);
    renderTimeline(p, pl, ev);
    renderSteps(p, pl);
    renderWhatIf(p, pl, ev);
    renderCompare();
    renderSend(pl);
  }

  function renderPick() {
    var p = S.main;
    if (!p) { els.pick.hidden = true; els.pick.innerHTML = ''; return; }
    els.pick.hidden = false;
    els.pick.innerHTML = (p.img ? '<img src="' + esc(p.img) + '" alt="" width="48" height="48">' : '') +
      '<span class="ltc-pick__t"><b>' + esc(p.item) + '</b><span>' + esc(p.name) + '</span></span>' +
      '<button type="button" class="ltc-pick__x" data-ltc-clear aria-label="Choose a different product">Change</button>';
  }

  function sumHead(p) {
    var tags = [];
    if (p.range) tags.push(daysTxt(p.range) + ' business days production');
    tags.push(whereTxt(p));
    var st = shipsTxt(p);
    if (st) tags.push(st);
    return '<div class="ltc-sum__prod">' +
      (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" width="112" height="112">' : '') +
      '<div class="ltc-sum__pt"><span class="ltc-sum__sku">' + esc(p.item) + '</span><a class="ltc-sum__name" href="' + esc(p.url) + '">' + esc(p.name) + '</a>' +
      '<div class="ltc-tags">' + tags.map(function (t) { return '<span class="ltc-tag">' + esc(t) + '</span>'; }).join('') + '</div></div></div>';
  }

  function transitLabel(p) {
    var t = transitFor(p);
    if (t.src === 'ups') return t.name + ' to ' + els.zip.value.trim() + ', ' + L.plural(t.days, 'business day');
    if (t.src === 'fixed') return t.name;
    if (t.src === 'wait') return t.name + ', checking with UPS…';
    if (t.src === 'fail') return t.name + ', up to ' + L.GROUND_ALLOWANCE + ' business days';
    return t.name + ', up to ' + L.GROUND_ALLOWANCE + ' business days. Add your ZIP for exact days';
  }

  function verdictHtml(p, pl, ev) {
    if (!ev) return '<div class="ltc-vd ltc-vd--none"><b>Add your in-hands date</b><span>We’ll tell you if this makes it and the last day to order.</span></div>';
    var v = L.verdict(pl, ev);
    var ob = L.orderBy(ev, opts(p));
    var approve = 'Approve the proof by ' + fd(pl.approve) + '.';
    if (v.kind === 'ok') {
      var sp = v.spare === 0 ? 'No spare day on the slow end' : L.plural(v.spare, 'business day') + ' to spare, even on the slow end';
      return '<div class="ltc-vd ltc-vd--ok">' + ICON.ok + '<div><b>Makes ' + esc(fd(ev)) + '</b><span>' + esc(sp) + '. ' + esc(approve) + '</span></div></div>';
    }
    var fast = fasterFix(p, ev);
    if (v.kind === 'maybe') {
      return '<div class="ltc-vd ltc-vd--maybe">' + ICON.warn + '<div><b>Might make ' + esc(fd(ev)) + '</b><span>Only if production takes the short end.' +
        (ob && ob >= pl.order ? ' To be safe, order by ' + esc(fd(ob)) + '.' : '') + (fast ? ' ' + esc(fast) : '') + '</span></div></div>';
    }
    return '<div class="ltc-vd ltc-vd--late">' + ICON.warn + '<div><b>Misses ' + esc(fd(ev)) + ' by ' + esc(v.over === v.overHi ? L.plural(v.over, 'business day') : v.over + '–' + v.overHi + ' business days') + '</b><span>' +
      (ob ? 'To make it, it needed ordering by ' + esc(fd(ob)) + '. ' : '') + (fast ? esc(fast) + ' ' : '') + 'Ask us about rush.</span></div></div>';
  }
  /* the slowest-safe faster UPS service that would make the date, if any */
  function fasterFix(p, ev) {
    var order = ['3day', '2day', '1day'];
    var cur = method();
    for (var i = 0; i < order.length; i++) {
      var m = order[i];
      var M = L.METHODS[m];
      if (cur === m || (L.METHODS[cur].days != null && M.days >= L.METHODS[cur].days)) continue;
      var pl = planFor(p, { transit: M.days });
      if (pl.handHi <= ev) return 'Shipping ' + M.name + ' gets it there by ' + fd(pl.handHi) + '.';
    }
    return '';
  }

  var ICON = {
    ok: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M7.5 12.5l3 3 6-6.5"></path></svg>',
    warn: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9v4M12 17h.01"></path><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"></path></svg>',
    flag: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 21V4M5 4h11l-2 4 2 4H5"></path></svg>'
  };

  function renderSum(p, pl, ev) {
    els.sum.innerHTML = sumHead(p) +
      '<div class="ltc-sum__dates">' +
        '<div class="ltc-kv"><span>Ships</span><b>' + esc(fr(pl.shipLo, pl.shipHi)) + '</b></div>' +
        '<div class="ltc-kv"><span>In hand</span><b>' + esc(fr(pl.handLo, pl.handHi)) + '</b><small>' + esc(transitLabel(p) + (L.weekendTag ? L.weekendTag(pl) : '')) + '</small></div>' +
      '</div>' + verdictHtml(p, pl, ev) +
      (p.direct ? '<p class="ltc-note">Made overseas: customs can add time to these dates.</p>' : '');
  }

  /* ── the day-by-day strip ── */
  function renderTimeline(p, pl, ev) {
    var start = pl.order;
    var end = pl.handHi;
    if (ev && ev > end && L.bizDiff(end, ev, 'US') <= 20) end = ev;
    var days = [];
    for (var d = L.clone(start); d <= end && days.length < MAX_DAYS; d = L.addDays(d, 1)) days.push(d);
    var idx = {};
    days.forEach(function (x, i) { idx[L.key(x)] = i; });
    function col(x) { var i = idx[L.key(x)]; return i == null ? -1 : i; }
    var tk = L.key(today());
    var evk = ev ? L.key(ev) : '';
    var cols = ['var(--ltc-lab)'];
    var head = ['<span class="ltc-tl__corner"></span>'];
    var bg = ['<span></span>'];
    days.forEach(function (x, i) {
      var w = x.getDay();
      var hol = L.holidayName(x, 'US') || (x >= pl.startLo && x <= pl.shipHi ? L.holidayName(x, p.cal) : null);
      var off = w === 0 || w === 6;
      cols.push(off || hol ? 'minmax(10px,.5fr)' : 'minmax(24px,1fr)');
      var showMonth = i === 0 || x.getDate() === 1;
      head.push('<span class="ltc-tl__d' + (off ? ' is-off' : '') + '"' + (hol ? ' title="' + esc(hol) + '"' : '') + '><span>' + L.DOW[w].charAt(0) + '</span><b>' + x.getDate() + '</b>' +
        (showMonth ? '<em>' + L.MON[x.getMonth()] + '</em>' : '<em></em>') + '</span>');
      var cls = off ? 'is-off' : (hol ? 'is-hol' : '');
      if (L.key(x) === tk) cls += ' is-today';
      if (L.key(x) === evk) cls += ' is-evt';
      bg.push('<span class="' + cls + '"' + (hol ? ' title="' + esc(hol) + '"' : '') + '></span>');
    });
    /* runs of business days in [a, b] on a calendar → grid spans */
    function runs(a, b, cal, cls) {
      var out = [], s = -1;
      for (var x = L.clone(a); x <= b; x = L.addDays(x, 1)) {
        var c = col(x);
        if (c < 0) continue;
        if (L.isBizDay(x, cal)) { if (s < 0) s = c; }
        else if (s > -1) { out.push(span(s, c - 1, cls)); s = -1; }
      }
      if (s > -1) out.push(span(s, col(b), cls));
      return out.join('');
    }
    function span(a, b, cls, inner) {
      if (a < 0) return '';
      if (b < 0 || b >= days.length) b = days.length - 1;
      if (b < a) return '';
      return '<span class="' + cls + '" style="grid-column:' + (a + 2) + ' / ' + (b + 3) + '">' + (inner || '') + '</span>';
    }
    function row(label, sub, content) {
      return '<div class="ltc-tg ltc-tr"><div class="ltc-tl__lab">' + esc(label) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</div>' + content + '</div>';
    }
    var rows = [];
    var oc = col(pl.order), rc = col(pl.received);
    rows.push(row('Order in', pl.received > pl.order ? 'Starts ' + short(pl.received) : 'Day 1',
      span(oc, oc, 'ltc-dot') + (rc !== oc ? span(rc, rc, 'ltc-dot ltc-dot--o') : '')));
    var proofC = col(pl.proof);
    var proofRow = span(proofC, proofC, 'ltc-bar');
    var proofSub = S.late ? 'Approved ' + short(pl.approve) : 'Approve same day';
    if (S.late && pl.approve > pl.proof) proofRow += runs(L.addDays(pl.proof, 1), pl.approve, 'US', 'ltc-bar ltc-bar--late');
    if (S.changes) { proofRow += runs(L.addDays(pl.approve, 1), pl.apprHi, 'US', 'ltc-bar ltc-bar--hatch'); proofSub = 'Plus 1–2 days for changes'; }
    rows.push(row('Proof', proofSub, proofRow));
    rows.push(row('Production', daysTxt(p.range) + ' business days',
      runs(pl.startLo, pl.shipLo, p.cal, 'ltc-bar') + (pl.shipHi > pl.shipLo ? runs(L.addDays(pl.shipLo, 1), pl.shipHi, p.cal, 'ltc-bar ltc-bar--hatch') : '')));
    var sl = col(pl.shipLo), sh = col(pl.shipHi);
    rows.push(row('Ships', shipsTxt(p).replace(/^Ships /, '') || '',
      span(sl, sl, 'ltc-dia') + (sh > sl ? (sh - sl > 1 ? span(sl + 1, sh - 1, 'ltc-link') : '') + span(sh, sh, 'ltc-dia ltc-dia--o') : '')));
    var t = transitFor(p);
    var trSolid = pl.transit ? runs(L.addDays(pl.shipLo, 1), pl.handLo, 'US', 'ltc-bar ltc-bar--ship') : '';
    var hatchFrom = pl.handLo > pl.shipHi ? L.addDays(pl.handLo, 1) : L.addDays(pl.shipHi, 1);
    var trHatch = pl.transit && pl.handHi > pl.handLo ? runs(hatchFrom, pl.handHi, 'US', 'ltc-bar ltc-bar--ship-h') : '';
    rows.push(row(t.name, t.src === 'ups' || t.src === 'fixed' ? L.plural(pl.transit, 'business day') : 'Up to ' + pl.transit + ' days', trSolid + trHatch));
    var hl = col(pl.handLo), hh = col(pl.handHi);
    var handLabel = L.key(pl.handLo) === L.key(pl.handHi) ? short(pl.handLo) : short(pl.handLo) + ' – ' + short(pl.handHi);
    var handRow = span(hl, hh, 'ltc-bar ltc-bar--hand', '<span>' + esc(handLabel) + '</span>');
    rows.push(row('In hand', zipOk() ? 'ZIP ' + els.zip.value.trim() : '', handRow));
    var ec = ev ? col(ev) : -1;
    if (ec > -1) rows.push(row('Your date', short(ev), span(ec, ec, 'ltc-flag', ICON.flag)));
    var note = ev && ec < 0 ? '<p class="ltc-tl__more">Your date, ' + esc(fd(ev)) + ', is past the end of this strip.</p>' : '';
    els.tl.innerHTML = '<div class="ltc-tl__in" style="--ltc-cols:' + cols.join(' ') + ';--ltc-n:' + days.length + '">' +
      '<div class="ltc-tg ltc-tl__bg" aria-hidden="true">' + bg.join('') + '</div>' +
      '<div class="ltc-tg ltc-tl__head" aria-hidden="true">' + head.join('') + '</div>' + rows.join('') + '</div>' + note;
  }

  function renderSteps(p, pl) {
    var li = [];
    function step(when, what) { li.push('<li><b>' + esc(when) + '</b> <span>' + esc(what) + '</span></li>'); }
    step(fd(pl.order), pl.received > pl.order ? 'Order placed. We start on ' + fd(pl.received) + '.' : 'Order placed.');
    step(fd(pl.proof), S.late ? 'Proof sent. Approved ' + fd(pl.approve) + '.' : 'Proof sent. Approve it the same day to keep these dates.');
    if (S.changes) step(fr(pl.apprLo, pl.apprHi), 'Changed proof approved.');
    step(L.key(pl.startLo) === L.key(pl.startHi) ? fd(pl.startLo) : fr(pl.startLo, pl.startHi), 'Production starts (' + daysTxt(p.range) + ' business days).');
    step(fr(pl.shipLo, pl.shipHi), 'Ships.');
    step(fr(pl.handLo, pl.handHi), 'In hand via ' + transitFor(p).name + (L.overWeekend && L.overWeekend(pl) ? '. UPS doesn’t deliver on weekends, so Saturday and Sunday aren’t counted.' : '.'));
    pl.closed.forEach(function (c) {
      var who = c.cal === 'CN' ? 'overseas factory' : c.cal === 'MX' ? 'factory in Mexico' : '';
      step(fd(c.date), (c.prod ? 'Production paused: ' : 'Closed: ') + c.name + (who ? ' (' + who + ')' : '') + '.');
    });
    els.steps.innerHTML = li.join('');
  }

  function renderWhatIf(p, pl, ev) {
    function vtxt(x) {
      if (!ev) return '';
      var v = L.verdict(x, ev);
      if (v.kind === 'ok') return '<span class="ltc-wi__v is-ok">' + (v.spare ? 'Makes ' + esc(fd(ev)) + ', ' + L.plural(v.spare, 'day') + ' to spare' : 'Makes ' + esc(fd(ev)) + ', no spare day') + '</span>';
      if (v.kind === 'maybe') return '<span class="ltc-wi__v is-maybe">Could miss ' + esc(fd(ev)) + '</span>';
      return '<span class="ltc-wi__v is-late">Misses ' + esc(fd(ev)) + '</span>';
    }
    var withCh = planFor(p, { changes: true });
    var withLate = planFor(p, { late: true });
    var cards = [];
    cards.push('<div class="ltc-wi__c"><button type="button" class="ltc-sw' + (S.changes ? ' on' : '') + '" role="switch" aria-checked="' + S.changes + '" data-ltc-wi="changes" aria-label="The proof needs changes"></button>' +
      '<div><b>The proof needs changes</b><span>Adds 1–2 business days. In hand as late as ' + esc(fd(withCh.handHi)) + '.</span>' + vtxt(withCh) + '</div></div>');
    cards.push('<div class="ltc-wi__c"><button type="button" class="ltc-sw' + (S.late ? ' on' : '') + '" role="switch" aria-checked="' + S.late + '" data-ltc-wi="late" aria-label="Approve the proof a day later"></button>' +
      '<div><b>Approve the proof a day later</b><span>Everything moves a business day: in hand ' + esc(fr(withLate.handLo, withLate.handHi)) + '.</span>' + vtxt(withLate) + '</div></div>');
    var cur = method();
    var alt = cur === 'ground' || cur === '3day' ? '2day' : cur === '2day' ? '1day' : 'ground';
    var A = L.METHODS[alt];
    var altPlan = alt === 'ground' ? planFor(p, { transit: zipOk() && typeof S.transit[p.oz + '>' + els.zip.value.trim()] === 'number' ? S.transit[p.oz + '>' + els.zip.value.trim()] : L.GROUND_ALLOWANCE }) : planFor(p, { transit: A.days });
    cards.push('<div class="ltc-wi__c"><span class="ltc-wi__ic" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h13v10H1zM14 10h4l3 3v3h-7z"></path><circle cx="5.5" cy="17.5" r="1.8"></circle><circle cx="17.5" cy="17.5" r="1.8"></circle></svg></span>' +
      '<div><b>Ship ' + esc(A.name) + '</b><span>In hand ' + esc(fr(altPlan.handLo, altPlan.handHi)) + '.</span>' + vtxt(altPlan) +
      '<button type="button" class="ltc-wi__btn" data-ltc-ship="' + alt + '">Use ' + esc(A.name.replace(/^UPS /, '')) + '</button></div></div>');
    els.wi.innerHTML = cards.join('');
  }

  /* ── compare ── */
  function renderCompare() {
    var list = S.items.filter(function (x) { return x && x.range; });
    var ev = inputDate(els.event);
    if (!list.length) { els.cmpRows.innerHTML = ''; els.cmpMsg.hidden = true; return; }
    var plans = list.map(function (x) { return planFor(x); });
    var start = plans[0].order;
    var end = plans[0].handHi;
    plans.forEach(function (pl) { if (pl.handHi > end) end = pl.handHi; });
    if (ev && ev > end) end = ev;
    var total = Math.max(1, Math.round((end - start) / 864e5) + 1);
    function pct(d) { return (Math.round((d - start) / 864e5) / total * 100).toFixed(2) + '%'; }
    function pctEnd(d) { return ((Math.round((d - start) / 864e5) + 1) / total * 100).toFixed(2) + '%'; }
    var ticks = '';
    for (var i = 0; i < total; i += 7) ticks += '<span style="left:' + (i / total * 100).toFixed(2) + '%">' + esc(L.MON[L.addDays(start, i).getMonth()] + ' ' + L.addDays(start, i).getDate()) + '</span>';
    var html = '<div class="ltc-gr ltc-gr--axis" aria-hidden="true"><span></span><div class="ltc-axis">' + ticks + '</div><span></span></div>';
    var missing = [];
    list.forEach(function (x, k) {
      var pl = plans[k];
      var v = ev ? L.verdict(pl, ev) : null;
      var vt, vc;
      if (!v) { vt = 'In hand ' + fr(pl.handLo, pl.handHi); vc = ''; }
      else if (v.kind === 'ok') { vt = '✓ In hand ' + fr(pl.handLo, pl.handHi); vc = 'is-ok'; }
      else if (v.kind === 'maybe') { vt = 'Could miss · ' + fr(pl.handLo, pl.handHi); vc = 'is-maybe'; missing.push([x, pl]); }
      else { vt = (v.over === v.overHi ? L.plural(v.over, 'day') : v.over + '–' + v.overHi + ' days') + ' late · ' + fr(pl.handLo, pl.handHi); vc = 'is-late'; missing.push([x, pl]); }
      html += '<div class="ltc-gr">' +
        '<div class="ltc-gr__p">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
          '<span><b>' + esc(x.name) + '</b><small>' + esc(x.item) + ' · ' + esc(daysTxt(x.range)) + ' days</small></span></div>' +
        '<div class="ltc-gr__track"><span class="ltc-gr__solid" style="width:' + pctEnd(pl.handLo) + '"></span>' +
          (pl.handHi > pl.handLo ? '<span class="ltc-gr__hatch" style="left:' + pctEnd(pl.handLo) + ';width:calc(' + pctEnd(pl.handHi) + ' - ' + pctEnd(pl.handLo) + ')"></span>' : '') +
          (ev ? '<span class="ltc-gr__evt" style="left:' + pctEnd(ev) + '"></span>' : '') + '</div>' +
        '<div class="ltc-gr__v ' + vc + '">' + esc(vt) +
          (k > 0 ? '<button type="button" class="ltc-gr__x" data-ltc-rm="' + esc(x.handle) + '" aria-label="Remove ' + esc(x.item) + '">×</button>' : '') + '</div>' +
        '</div>';
    });
    els.cmpRows.innerHTML = list.length > 1 || ev ? html : '';
    var msg = '';
    if (list.length > 1) {
      if (ev && missing.length) {
        msg = '<b>' + missing.length + ' of ' + list.length + ' items ' + (missing.length === 1 ? 'misses ' : 'miss ') + esc(fd(ev)) + '.</b> ' +
          missing.map(function (m) { var ob = L.orderBy(ev, opts(m[0])); return ob ? esc(m[0].item) + (ob >= m[1].order ? ' must be ordered by ' : ' needed ordering by ') + esc(fd(ob)) : ''; }).filter(Boolean).join('; ') +
          '. Ask us about rush, or pick a faster product.';
      } else {
        var slow = 0;
        plans.forEach(function (pl, k) { if (pl.handHi > plans[slow].handHi) slow = k; });
        msg = ev ? '<b>Everything makes ' + esc(fd(ev)) + '.</b> The last item, ' + esc(list[slow].item) + ', arrives by ' + esc(fd(plans[slow].handHi)) + '.'
          : '<b>' + esc(list[slow].item) + ' arrives last:</b> ' + esc(fr(plans[slow].handLo, plans[slow].handHi)) + '. Add your in-hands date to check them all.';
      }
    }
    els.cmpMsg.innerHTML = msg;
    els.cmpMsg.hidden = !msg;
    els.cmpMsg.className = 'ltc-cmp-msg' + (ev && missing.length ? ' is-late' : '');
  }

  /* ── send ── */
  function planText(p, pl) {
    var ev = inputDate(els.event);
    var lines = [p.name + ' (' + p.item + ')', '', 'Order date: ' + fd(pl.order), 'Proof: ' + fd(pl.proof) + ' (approve the same day to keep these dates)',
      'Production: ' + daysTxt(p.range) + ' business days', 'Ships: ' + fr(pl.shipLo, pl.shipHi), 'In hand: ' + fr(pl.handLo, pl.handHi) + ' (' + transitFor(p).name + ')'];
    if (ev) {
      var v = L.verdict(pl, ev);
      lines.push('Your date: ' + fd(ev) + (v.kind === 'ok' ? ' (on track)' : v.kind === 'maybe' ? ' (tight)' : ' (needs a faster option)'));
    }
    S.items.slice(1).forEach(function (x) { if (!x.range) return; var q = planFor(x); lines.push(x.name + ' (' + x.item + '): in hand ' + fr(q.handLo, q.handHi)); });
    lines.push('', 'Dates are estimates. Production starts the business day after the proof is approved.');
    return lines.join('\n');
  }
  function renderSend(pl) {
    var p = S.main;
    els.quote.href = p ? p.url + '?action=quote' : '#';
    els.quote.textContent = inputDate(els.event) ? 'Request a quote for ' + fd(inputDate(els.event)) : 'Request a quote';
    if (pl) {
      var co = els.company.value.trim();
      els.mail.href = 'mailto:?subject=' + encodeURIComponent('Timeline for ' + p.name + (co ? ' from ' + co : '')) + '&body=' + encodeURIComponent(planText(p, pl) + (co ? '\n\n' + co : ''));
      els.printHead.innerHTML = '<b>' + esc(co || 'Production timeline') + '</b><span>' + esc(co ? 'Production timeline' : '') + '</span><span>Prepared ' + esc(L.fmt(today(), true)) + '</span>';
    }
  }
  function say(t) { els.status.textContent = t; clearTimeout(say.t); say.t = setTimeout(function () { els.status.textContent = ''; }, 4000); }

  /* ── address bar: a link to this plan ── */
  function syncUrl() {
    if (!window.history || !history.replaceState) return;
    var u = new URL(location.href);
    ['sku', 'productSku', 'add', 'from', 'date', 'zip', 'ship'].forEach(function (k) { u.searchParams.delete(k); });
    if (S.main) u.searchParams.set('sku', S.main.item || S.main.handle);
    var more = S.items.slice(1).map(function (x) { return x.item || x.handle; });
    if (more.length) u.searchParams.set('add', more.join(','));
    var od = inputDate(els.order);
    if (od && L.key(od) !== L.key(today())) u.searchParams.set('from', L.key(od));
    var ev = inputDate(els.event);
    if (ev) u.searchParams.set('date', L.key(ev));
    if (zipOk()) u.searchParams.set('zip', els.zip.value.trim());
    if (method() !== 'ground') u.searchParams.set('ship', method());
    history.replaceState(null, '', u.pathname + (u.search ? u.search : '') + u.hash);
  }

  /* ── wiring ── */
  combo(els.q, els.list, function (p) { setMain(p); });
  combo(els.cmpQ, els.cmpList, function (p) { addItem(p); els.cmpQ.focus(); });

  els.order.value = L.key(today());
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!S.main) {
      var q = els.q.value.trim();
      if (!q) { els.err.textContent = 'Pick a product first: search by name or item number.'; els.err.hidden = false; els.q.focus(); return; }
      lookupSku(q).then(function (p) {
        if (p) { setMain(p); scrollToResults(); }
        else { els.err.textContent = 'We couldn’t find “' + q + '”. Try the item number, or pick from the list as you type.'; els.err.hidden = false; }
      });
      return;
    }
    render();
    syncUrl();
    scrollToResults();
  });
  function scrollToResults() {
    var r = els.results;
    if (!r || r.hidden) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    r.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  [els.order, els.event, els.ship].forEach(function (el) { el.addEventListener('change', function () { render(); syncUrl(); }); });
  els.zip.addEventListener('input', function () {
    var v = els.zip.value.replace(/\D/g, '').slice(0, 5);
    if (v !== els.zip.value) els.zip.value = v;
    if (v.length === 5 || v.length === 0) { render(); syncUrl(); }
  });
  els.pick.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ltc-clear]')) return;
    els.q.focus();
  });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ltc-wi],[data-ltc-ship],[data-ltc-rm],[data-ltc-try]');
    if (!t) return;
    if (t.hasAttribute('data-ltc-wi')) {
      var k = t.getAttribute('data-ltc-wi');
      S[k] = !S[k];
      render();
      var again = root.querySelector('[data-ltc-wi="' + k + '"]');
      if (again) again.focus();
    } else if (t.hasAttribute('data-ltc-ship')) {
      els.ship.value = t.getAttribute('data-ltc-ship');
      render(); syncUrl();
      var sw = root.querySelector('[data-ltc-ship]');
      if (sw) sw.focus();
    } else if (t.hasAttribute('data-ltc-rm')) {
      var h = t.getAttribute('data-ltc-rm');
      S.items = S.items.filter(function (x, i) { return i === 0 || x.handle !== h; });
      render(); syncUrl();
      els.cmpAdd.focus();
    } else if (t.hasAttribute('data-ltc-try')) {
      lookupSku(t.getAttribute('data-ltc-try')).then(function (p) { if (p) { setMain(p); scrollToResults(); } });
    }
  });
  els.cmpAdd.addEventListener('click', function () {
    els.cmpCombo.hidden = false;
    els.cmpQ.focus();
  });
  var CO_KEY = 'ltc_company';
  try { els.company.value = localStorage.getItem(CO_KEY) || ''; } catch (e) {}
  els.company.addEventListener('input', function () {
    try { localStorage.setItem(CO_KEY, els.company.value.trim()); } catch (e) {}
    if (S.main && S.main.range) renderSend(planFor(S.main));
  });
  els.copy.addEventListener('click', function () {
    syncUrl();
    var link = location.href;
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = link; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      say(ok ? 'Link copied.' : 'Copy this link: ' + link);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(function () { say('Link copied.'); }, fallback);
    else fallback();
  });
  els.print.addEventListener('click', function () { window.print(); });

  /* ── start: a link to a plan (?sku=…&add=…&date=…&zip=…&ship=…&from=…) ── */
  (function boot() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var from = L.parseDate(q.get('from'));
    if (from) els.order.value = L.key(from);
    var date = L.parseDate(q.get('date'));
    if (date) els.event.value = L.key(date);
    var zip = (q.get('zip') || '').replace(/\D/g, '');
    if (zip.length === 5) els.zip.value = zip;
    var ship = q.get('ship');
    if (ship && L.METHODS[ship]) els.ship.value = ship;
    var sku = q.get('sku') || q.get('productSku');
    if (!sku) return;
    var adds = (q.get('add') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, MAX_ITEMS - 1);
    lookupSku(sku).then(function (p) {
      if (!p) { els.err.textContent = 'We couldn’t find “' + sku + '”. Search for it above.'; els.err.hidden = false; return; }
      setMain(p, true);
      return Promise.all(adds.map(lookupSku)).then(function (more) {
        more.forEach(function (m) { if (m && m.handle !== p.handle && S.items.length < MAX_ITEMS) S.items.push(m); });
        render();
      });
    });
  })();
})();
